import config from "@Config/index";
import axios from "axios";

const fetchInventory = async (
  { id, regionId, token, selectedLang, userCurrency, useJavaApi = true }: any,
  additionalParams: any = {},
) => {
  const language = selectedLang;
  const params = {
    type: "",
    region_id: regionId,
    lang: language || "en",
    methods: `
    region,reviews_count,provider_data_supply_bd_agent_name,reviews_rating,site_plan,meta_facts,meta_distances,feature_tags,destination_distances,children_short,location_coordinates,meta_general_facts,meta_community_facts,region_parent_country,amber_sales,whitelabel_partner_ids,property_residents_insights,include_accreditations,region_meta,nearby_distances,neighbourhood_sentences`,
    ...additionalParams,
    ...(token ? { user_auth_token: token } : {}),
    ...(useJavaApi ? { use_java_api: true } : {}),
  };
  if (userCurrency) {
    params["user_currency"] = userCurrency;
  }

  const optionHeaders: any = {};
  if (useJavaApi) {
    optionHeaders["X-Use-Java-Api"] = "true";
  }
  return axios.get(`${config.API_URL}/api/v0/inventories/${id}`, {
    params,
    withCredentials: true,
    ...optionHeaders,
  });
};

export default fetchInventory;
